var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BaseDialog',{attrs:{"append-to-body":"","title":"提醒"},on:{"confirm":function($event){return _vm.$emit('confirm')},"close":function($event){return _vm.$emit('close')}}},[_c('div',{staticClass:"modal-body"},[_c('p',[_vm._v("部份日期已有排班紀錄，點擊確定將會覆蓋現有排班班別，請問確定要覆蓋嗎？")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }